export default "__VITE_ASSET__ed7dcb59__"